@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.home-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden scroll;
  background-color: var(--Surface-Default);
  background-image: url('../bg--cubes.svg');
  background-size: 500px;
  background-repeat: no-repeat;
  background-position: right 0 top -45px;
}

.cards-and-sidebar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.promotional-banner {
  margin-top: @space-32;
  width: 80%;
  align-self: center;

  // the page is slightly off center so we try to account for that
  margin-left: -@space-4;
}

.cards-and-sidebar {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  gap: @space-32;
  margin: @space-32 @space-0;
  padding: @space-0 @space-16;
  width: 100%;
  max-width: 1264px;
}
